import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "./Button";
import { Link } from "react-router-dom";
import Logo from "../assets/New-logo.png";
import { CartContext } from "../context/CartContext";
import { AuthContext } from "../context/AuthContext";
import "./Navbar.css";
import CartPage from "./CartPage";
import FormatPrice from "../helper/FormatPrice";

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const { cartItems, temporaryCartItems, totalAmount } =
    useContext(CartContext);
  const { token, userName, userType } = useContext(AuthContext);

  // console.log(token, userId, userType, "token");

  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("userType");
    // navigate('/login');
  };

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 1024) {
      setButton(true);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, [cartItems, CartContext]);

  const loggedInUser = localStorage.getItem("token");

  window.addEventListener("resize", showButton);

  // const cartQty = cartItems.reduce(
  //   (accumulator, currentValue) => accumulator + currentValue.quantity,
  //   0
  // );
  // console.log('̥cartItems', cartQty);

  return (
    <>
      <div className="top-bar">
        <p>FREE Shipping & FREE Returns.</p>
      </div>
      <div className="navbar-logo">
        <Link to="/" className="navbar-logo">
          <img src={Logo} className="logo" alt="Logo" />
        </Link>
      </div>
      <div className="navbar">
        <div className="navbar-container container">
          <div className="row w-100">
            <div className="col-xl-2 col-lg-3 col-md-3 col-6 text-align-center">
              <div className="nav-icon mb-0">
                {button && <Button buttonStyle="btn__outline">Store</Button>}
                {button && <Button buttonStyle="btn__outline">Contact</Button>}
              </div>
            </div>
            <div className="col-xl-8 col-lg-6 col-md-6 col-1 text-align-center ">
              <div className="menu-icon" onClick={handleClick}>
                <i
                  className={click ? "fa-solid fa-xmark" : "fa-solid fa-bars"}
                />
              </div>

              <ul className={click ? "nav-menu active" : "nav-menu"}>
                <li className="nav-item dropdown dropdown-hover position-static">
                  <Link
                    to="/engagement"
                    className="nav-link dropdown-hover"
                    href="#"
                    id="navbarDropdown"
                    role="button"
                    data-mdb-hover="dropdown"
                    aria-expanded="false"
                    onClick={closeMobileMenu}
                  >
                    Engagement
                  </Link>

                  {/* <!-- Dropdown menu --> */}
                  <div
                    className="dropdown-menu w-100 mt-0"
                    aria-labelledby="navbarDropdown"
                  >
                    <div className="container">
                      <div className="row my-4">
                        <div className="col-sm-6 col-12">
                          <h5 className="ps-3 mb-4">
                            <b>Pre-Designed Engagement Ring</b>
                          </h5>
                          <div className="row">
                            <div className="col-md-6 col-lg-4 mb-3 mb-lg-0">
                              <div className="list-group list-group-flush">
                                <h6 className="list-group-item">
                                  <b>Shop by Setting</b>
                                </h6>
                                <a
                                  href="/engagement"
                                  className="list-group-item list-group-item-action"
                                >
                                  Solitaire
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Side Stone
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Halo
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Hidden Halo
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Three Stone
                                </a>
                              </div>
                            </div>
                            <div className="col-md-6 col-lg-4 mb-3 mb-lg-0">
                              <div className="list-group list-group-flush">
                                <h6 className="list-group-item">
                                  <b>Shop by Shape</b>
                                </h6>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Round
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Oval
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Cushion
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Emerald
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Pear
                                </a>
                              </div>
                            </div>
                            <div className="col-md-6 col-lg-4 mb-3 mb-md-0">
                              <div className="list-group list-group-flush">
                                <h6 className="list-group-item">
                                  <b>Shop by metal</b>
                                </h6>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Yellow Gold
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  White Gold
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Rose Gold
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Platinum
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Silver
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-sm-6 col-12">
                          <h5 className="ps-3 mb-4">
                            <b>Create your own Engagement Ring</b>
                          </h5>
                          <div className="row">
                            <div className="col-md-6 mb-3 mb-lg-0">
                              <div className="list-group list-group-flush">
                                <h6 className="list-group-item">
                                  <b>Shop by Setting</b>
                                </h6>
                                <a
                                  href="/engagement"
                                  className="list-group-item list-group-item-action"
                                >
                                  Start with a Setting
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Start with a Diamond
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Start with a Lab Grown Diamond
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Start with a Gemstone
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Start with a Bridal Set
                                </a>
                              </div>
                            </div>
                            <div className="col-md-6 mb-3 mb-lg-0">
                              <div className="list-group list-group-flush">
                                <h6 className="list-group-item">
                                  <b>Education</b>
                                </h6>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Engagement Ring Guide
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  How Much to Spend on an Engagement Ring
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  How to Choose a Diamond
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Platinum vs. Gold
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Ring Size Chart
                                </a>
                              </div>
                            </div>

                            {/* <div className="col-md-6 col-lg-4 mb-3 mb-lg-0">
                              <img src={require('../assets/ring-collection.jpg')} className="w-100" alt="" />
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="nav-item dropdown dropdown-hover position-static">
                  <Link
                    to="/wedding-rings"
                    className="nav-link dropdown-hover"
                    id="navbarDropdown"
                    role="button"
                    data-mdb-hover="dropdown"
                    aria-expanded="false"
                    onClick={closeMobileMenu}
                  >
                    Wedding
                  </Link>

                  {/* <!-- Dropdown menu --> */}
                  <div
                    className="dropdown-menu w-100 mt-0"
                    aria-labelledby="navbarDropdown"
                  >
                    <div className="container">
                      <div className="row my-4">
                        <div className="col-sm-4 col-12">
                          <h5 className="ps-3 mb-4">
                            <b>Pre-Designed Wedding Ring</b>
                          </h5>
                          <div className="row">
                            <div className="col-md-6 col-lg-4 mb-3 mb-lg-0">
                              <div className="list-group list-group-flush">
                                <h6 className="list-group-item">
                                  <b>Setting</b>
                                </h6>
                                <a
                                  href="/wedding-rings"
                                  className="list-group-item list-group-item-action"
                                >
                                  Solitaire
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Side Stone
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Halo
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Hidden Halo
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Three Stone
                                </a>
                              </div>
                            </div>
                            <div className="col-md-6 col-lg-4 mb-3 mb-lg-0">
                              <div className="list-group list-group-flush">
                                <h6 className="list-group-item">
                                  <b>Shape</b>
                                </h6>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Round
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Oval
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Cushion
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Emerald
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Pear
                                </a>
                              </div>
                            </div>
                            <div className="col-md-6 col-lg-4 mb-3 mb-md-0">
                              <div className="list-group list-group-flush">
                                <h6 className="list-group-item">
                                  <b>Shop by metal</b>
                                </h6>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Yellow Gold
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  White Gold
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Rose Gold
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Platinum
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Silver
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-sm-4 col-12">
                          <h5 className="ps-3 mb-4">
                            <b>Wedding Collection</b>
                          </h5>
                          <div className="row">
                            <div className="col-md-6 mb-3 mb-lg-0">
                              <div className="list-group list-group-flush">
                                <h6 className="list-group-item">
                                  <b>Women Rings</b>
                                </h6>
                                <a
                                  href="/engagement"
                                  className="list-group-item list-group-item-action"
                                >
                                  Women's Wedding Rings
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Diamond Rings
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Create Your Own Ring Stack
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Find My Matching Wedding Ring
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Eternity Rings
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Anniversary Rings
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Curved Rings
                                </a>
                              </div>
                            </div>
                            <div className="col-md-6 mb-3 mb-lg-0">
                              <div className="list-group list-group-flush">
                                <h6 className="list-group-item">
                                  <b>Men Rings</b>
                                </h6>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Men's Wedding Rings
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Classic Rings
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Men's Engagement Rings
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Customize Your Own Ring
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Matte Rings
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Diamonds and Gemstones
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Textured Rings
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Men's Jewelry
                                </a>
                              </div>
                            </div>

                            {/* <div className="col-md-6 col-lg-4 mb-3 mb-lg-0">
                              <img src={require('../assets/ring-collection.jpg')} className="w-100" alt="" />
                            </div> */}
                          </div>
                        </div>

                        <div className="col-sm-4 col-12">
                          <h5 className="ps-3 mb-4">
                            <b>Create your own Wedding Ring</b>
                          </h5>
                          <div className="row">
                            <div className="col-md-6 mb-3 mb-lg-0">
                              <div className="list-group list-group-flush">
                                <h6 className="list-group-item">
                                  <b>Shop by Setting</b>
                                </h6>
                                <a
                                  href="/engagement"
                                  className="list-group-item list-group-item-action"
                                >
                                  Start with a Setting
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Start with a Diamond
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Start with a Lab Grown Diamond
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Start with a Gemstone
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Start with a Bridal Set
                                </a>
                              </div>
                            </div>
                            <div className="col-md-6 mb-3 mb-lg-0">
                              <div className="list-group list-group-flush">
                                <h6 className="list-group-item">
                                  <b>Education</b>
                                </h6>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Engagement Ring Guide
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  How Much to Spend on an Engagement Ring
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  How to Choose a Diamond
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Platinum vs. Gold
                                </a>
                                <a
                                  href=""
                                  className="list-group-item list-group-item-action"
                                >
                                  Ring Size Chart
                                </a>
                              </div>
                            </div>

                            {/* <div className="col-md-6 col-lg-4 mb-3 mb-lg-0">
                              <img src={require('../assets/ring-collection.jpg')} className="w-100" alt="" />
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="nav-item dropdown dropdown-hover position-static">
                  <Link
                    to="/engagement"
                    className="nav-link dropdown-hover"
                    href="#"
                    id="navbarDropdown"
                    role="button"
                    data-mdb-hover="dropdown"
                    aria-expanded="false"
                    onClick={closeMobileMenu}
                  >
                    Jewelry
                  </Link>

                  {/* <!-- Dropdown menu --> */}
                  <div
                    className="dropdown-menu w-100 mt-0"
                    aria-labelledby="navbarDropdown"
                  >
                    <div className="container">
                      <div className="row my-4">
                        <div className="col">
                          <div className="list-group list-group-flush">
                            <h6 className="list-group-item">
                              <b>Rings</b>
                            </h6>
                            <a
                              href="/engagement"
                              className="list-group-item list-group-item-action"
                            >
                              Fashion Rings
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              Fashion Bands
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              New Arrivals
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              In-Stock
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              Three Stone
                            </a>
                          </div>
                        </div>
                        <div className="col">
                          <div className="list-group list-group-flush">
                            <h6 className="list-group-item">
                              <b>Earrings</b>
                            </h6>
                            <a
                              href="/engagement"
                              className="list-group-item list-group-item-action"
                            >
                              Diamond Studs
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              Hoops
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              Fashion Earrings
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              Earring Jackets
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              New Arrivals
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              In-Stock
                            </a>
                          </div>
                        </div>
                        <div className="col">
                          <div className="list-group list-group-flush">
                            <h6 className="list-group-item">
                              <b>Necklaces</b>
                            </h6>
                            <a
                              href="/engagement"
                              className="list-group-item list-group-item-action"
                            >
                              Tennis Necklaces
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              Fashion Necklaces
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              Solitaire Pendants
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              Fashion Pendants
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              New Arrivals
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              In-Stock
                            </a>
                          </div>
                        </div>
                        <div className="col">
                          <div className="list-group list-group-flush">
                            <h6 className="list-group-item">
                              <b>Bracelets</b>
                            </h6>
                            <a
                              href="/engagement"
                              className="list-group-item list-group-item-action"
                            >
                              Tennis Bracelets
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              Fashion Bracelets
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              Bangles
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              New Arrivals
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              In-Stock
                            </a>
                          </div>
                        </div>
                        <div className="col">
                          <div className="list-group list-group-flush">
                            <h6 className="list-group-item">
                              <b>Men's</b>
                            </h6>
                            <a
                              href="/engagement"
                              className="list-group-item list-group-item-action"
                            >
                              Rings
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              Earrings
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              Necklaces
                            </a>
                            <a
                              href=""
                              className="list-group-item list-group-item-action"
                            >
                              Bracelets
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                {/* <li>
                  <Link to="/allproducts" className="nav-link" onClick={closeMobileMenu}>All Products</Link>
                </li>
                <li>
                  <Link to="/login" className="nav-link" onClick={closeMobileMenu}>Login</Link>
                </li> */}
                <li className="nav-item">
                  <Link
                    to="/diamond-slider"
                    className="nav-link"
                    onClick={closeMobileMenu}
                  >
                    Search Loose Diamonds
                  </Link>
                </li>
                {userType === "admin" && loggedInUser && (
                  <>
                    <li className="nav-item">
                      <Link
                        to="/dashboard"
                        className="nav-link"
                        onClick={closeMobileMenu}
                      >
                        Dashboard
                      </Link>
                    </li>
                  </>
                )}
              </ul>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-3 col-5 text-align-center">
              <div className="nav-icon">
                {button && (
                  <Button buttonStyle="btn__outline">
                    <i className="fa-solid fa-heart"></i>
                  </Button>
                )}
                <Link
                  to="/login"
                  onClick={closeMobileMenu}
                  className="position-relative account-icon"
                >
                  {button && (
                    <Button buttonStyle="btn__outline">
                      <div className="d-flex align-items-center justify-content-between p-1 my-0">
                        {loggedInUser ? (
                          <>
                            <i className="fa-solid fa-user me-3"></i>
                            <span className="text-start iconUser fw-light">
                              {userName.split(" ")[0]}
                            </span>
                          </>
                        ) : (
                          <i className="fa-solid fa-user"></i>
                        )}
                      </div>
                    </Button>
                  )}

                  {loggedInUser && (
                    <div className="account-navlist">
                      <span onClick={handleLogout}>Logout</span>
                    </div>
                  )}
                </Link>

                <Link to="/cart">
                  {loggedInUser
                    ? button && (
                        <Button buttonStyle="btn__outline">
                          <div className="d-flex align-items-center justify-content-between p-1 my-0">
                            <i className="fa-solid fa-cart-shopping me-3"></i>
                            {cartItems.length > 0 && (
                              <>
                                <span className="cart-counter">
                                  {cartItems.length}
                                </span>
                                {totalAmount && (
                                  <span className="text-start iconUser fw-light">
                                    {<FormatPrice price={totalAmount} />}
                                  </span>
                                )}
                              </>
                            )}
                          </div>
                        </Button>
                      )
                    : button && (
                        <Button buttonStyle="btn__outline">
                          <div className="d-flex align-items-center justify-content-between p-1 my-0">
                            {temporaryCartItems.length > 0 && totalAmount ? (
                              <>
                                <i className="fa-solid fa-cart-shopping me-3"></i>

                                <span className="cart-counter">
                                  {temporaryCartItems.length}
                                </span>

                                <span className="text-start iconUser fw-light">
                                  {<FormatPrice price={totalAmount} />}
                                </span>
                              </>
                            ) : (
                              <i className="fa-solid fa-cart-shopping"></i>
                            )}
                          </div>
                        </Button>
                      )}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Navbar;
